import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './components/privateRoute';
import LoginPage from './pages/loginPage';
import DashboardPage from './pages/dashboardPage';
import HistoricalPage from './pages/historicalPage';
import CustomTrendPage from './pages/customTrendPage';
import AdministrationPage from './pages/administration/administrationPage';
import UserAdminPage from './pages/administration/users/usersPage';
import OrganizationAdminPage from './pages/administration/organization/organizationPage';
import DeviceAdminPage from './pages/administration/devices/devicesPage';
import RoleAdminPage from './pages/administration/users/rolePage';
import MyProfilePage from './pages/administration/users/myProfilePage';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PrivateRoute>< DashboardPage/></PrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute>< DashboardPage/></PrivateRoute>} />
        <Route path="/history" element={<PrivateRoute>< HistoricalPage/></PrivateRoute>} />
        <Route path="/custom" element={<PrivateRoute>< CustomTrendPage/></PrivateRoute>} />
        <Route path="/administration" element={<PrivateRoute>< AdministrationPage/></PrivateRoute>} />
        <Route path="/admin/users" element={<PrivateRoute>< UserAdminPage/></PrivateRoute>} />
        <Route path="/admin/organizations" element={<PrivateRoute>< OrganizationAdminPage/></PrivateRoute>} />
        <Route path="/admin/devices" element={<PrivateRoute>< DeviceAdminPage/></PrivateRoute>} />
        <Route path="/admin/roles" element={<PrivateRoute>< RoleAdminPage/></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute>< MyProfilePage/></PrivateRoute>} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
